module.exports = __webpack_public_path__ + "media/customizations/regencyatesperanza/logo-148f1eaf692f92bb4e3490f7ef41bb10.png";